import { getOneRandom } from './../utils/array';

const jab = () => 'jab'

const cross = () => 'cross'

const hook = (side) => `${side === 'lead' ? 'lead' : 'rear'} hook`;

const uppercut = (side) => `${side === 'lead' ? 'lead' : 'rear'} uppercut`;

const slip = (side) => `slip ${side === 'lead' ? 'back' : 'forward'}`;

const roll = (side) => `roll ${side === 'lead' ? 'back' : 'forward'}`;

const leadPunches = [
  jab(),
  hook('lead'),
  uppercut('lead')
];

const leadMoves = [
  ...leadPunches,
  slip('lead'),
  roll('lead')
];

const rearPunches = [
  cross(),
  hook('rear'),
  uppercut('rear')
];

const rearMoves = [
  ...rearPunches,
  slip('rear'),
  roll('rear')
];

const burnouts = [
  [jab(), cross()],
  [hook('lead'), hook('rear')],
  [uppercut('lead'), uppercut('rear')],
  [uppercut('lead'), hook('rear')],
  [hook('lead'), uppercut('rear')],
  [hook('lead'), cross()],
];

const randomBurnout = () => getOneRandom(burnouts);

export { jab, cross, hook, uppercut, slip, roll, leadPunches, leadMoves, rearPunches, rearMoves, burnouts, randomBurnout };
